import React from "react";
import "../styles/HomePage.css";
import CustomButton from "../components/CustomButton";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Timeline from "../components/Timeline";
import Services from "../components/Services";

import { useNavigate } from 'react-router-dom';
import CTASection from "../components/CTASection";
import StatsSection from "../components/StatsSection";
import PortfolioSection from "./PortfolioSpotlight";
import { motion } from "framer-motion";

const HomePage = () => {
  const navigate = useNavigate();
  return (<>
      <Navbar />
    <div className="portfolio-container">

      <section className="hero-section section-container">
        <motion.div 
          className="trusted-badge"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          🚀 Trusted by 50+ Leading Brands Worldwide
        </motion.div>
        <motion.h1 
          className="hero-title"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Transform Your Vision Into
          <span style={{ color: '#182cd4' }}> Digital Reality</span>
        </motion.h1>
        <motion.div 
          className="feature-badges"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.15
              }
            }
          }}
        >
          <motion.div 
            className="feature-badge"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            🎯 100% Success Rate, 100% Satisfaction
          </motion.div>
          <motion.div 
            className="feature-badge"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.55 }}
          >
            ⚡ Lightning-Fast Delivery, Never Miss Deadlines
          </motion.div>
          <motion.div 
            className="feature-badge"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.7 }}
          >
            🌍 24/7 Global Support, 5+ Time Zones
          </motion.div>
        </motion.div>
        <motion.p 
          className="hero-description"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.9 }}
        >
          We don't just build websites – we create digital experiences that 
          <strong> skyrocket your business growth</strong> and leave your competitors in the dust. 
          From concept to launch, we turn your boldest ideas into reality.
        </motion.p>
        <motion.div 
          className="hero-cta"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 1.1 }}
        >
          <CustomButton variant="contained" onClick={() => window.open('https://wa.link/u4vxgs?text=Hi%2C%20I%20want%20to%20start%20a%20project%20with%20Vionex%20Labs', '_blank')}>
            🚀 Start Your Project
          </CustomButton>
          <CustomButton variant="outlined" onClick={() => navigate('/portfolio')}>
            ✨ See Our Magic
          </CustomButton>
        </motion.div>
      </section>

      <StatsSection />

      <section className="services-section section-container">
        <Timeline />

        <Services />

      <PortfolioSection />

           <CTASection />

      </section>

     <Footer/>
    </div>
    </>
  );
};

export default HomePage;
